var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpthomology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.09277,
    y: 1.21094,
    width: 72.8042,
    height: 72.8042,
    rx: 7.5,
    stroke: "black",
    strokeDasharray: "2 2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "black",
    clipRule: "evenodd",
    d: "M18.9743 36.1128C20.9315 33.8972 23.9019 31.359 27.7149 29.6314C25.7168 31.8471 24.5003 34.7815 24.5003 38C24.5003 41.2185 25.7168 44.1529 27.7149 46.3686C23.9019 44.641 20.9315 42.1028 18.9743 39.8872C18.009 38.7946 18.009 37.2054 18.9743 36.1128ZM17.4129 34.7335C20.9628 30.7149 27.71 25.5966 36.8147 25.5014C36.8765 25.5004 36.9383 25.5 37.0003 25.5H37.0306H37.0729C46.3082 25.5 53.1495 30.6771 56.7329 34.7335C58.3941 36.6141 58.3941 39.3859 56.7329 41.2665C53.1495 45.3229 46.3082 50.5 37.0729 50.5H37.0306H37.0003C36.9383 50.5 36.8765 50.4996 36.8147 50.4986C27.71 50.4034 20.9628 45.2851 17.4129 41.2665C15.7517 39.3859 15.7517 36.6141 17.4129 34.7335ZM37.0299 27.5833C36.9667 27.5835 36.9036 27.5839 36.8405 27.5846C31.1613 27.6699 26.5837 32.3004 26.5837 38C26.5837 43.6996 31.1613 48.3301 36.8405 48.4154C36.9036 48.4161 36.9667 48.4165 37.0299 48.4167C42.7693 48.4007 47.417 43.7431 47.417 38C47.417 32.2569 42.7693 27.5993 37.0299 27.5833ZM49.5003 38C49.5003 41.2718 48.2433 44.2499 46.1859 46.4779C50.1168 44.7494 53.1726 42.15 55.1715 39.8872C56.1368 38.7946 56.1368 37.2054 55.1715 36.1128C53.1726 33.85 50.1168 31.2506 46.1859 29.5221C48.2433 31.7501 49.5003 34.7282 49.5003 38ZM37.0728 44.25C40.5246 44.25 43.3228 41.4518 43.3228 38C43.3228 37.0351 43.1042 36.1214 42.7138 35.3054C42.3367 35.683 41.8154 35.9167 41.2396 35.9167C40.089 35.9167 39.1563 34.984 39.1563 33.8333C39.1563 33.2575 39.3899 32.7363 39.7675 32.3592C38.9516 31.9686 38.0377 31.75 37.0728 31.75C33.6211 31.75 30.8228 34.5482 30.8228 38C30.8228 41.4518 33.6211 44.25 37.0728 44.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpthomology);
export default __webpack_public_path__ + "static/media/opthomology.56c5c119d281d8650ef49e24c3f2f7a0.svg";
export { ForwardRef as ReactComponent };